<template>
  <div class="personal">
    <div class="left">
      <div
        v-for="(item,index) in tabList"
        :key="index"
        class="personal_tab"
        :class="tabIndex===index?'active':''"
        @click="tabClick(index)"
      >{{ item.name }}</div>
    </div>
    <div class="right">
      <div class="title"><span />{{ tabIndex===0?'基本设置':'安全设置' }}</div>
      <el-form ref="form" label-position="top" :model="form" label-width="80px">
        <div v-if="tabIndex===0">
          <el-form-item label="头像">
            <div class="avtar_box">
              <img :src="form.avatar" class="avtar">
              <uploadBtn @changeImg="changeImg" />
            </div>
          </el-form-item>
          <el-form-item label="昵称">
            <el-input v-model="form.nickname" size="medium" :disabled="!showBtn">
              <i slot="suffix" class="el-input__icon el-icon-edit" />
            </el-input>
          </el-form-item>
          <el-form-item label="真实姓名">
            <el-input v-model="form.realname" size="medium" disabled />
          </el-form-item>
          <el-form-item label="医院">
            <el-select v-model="form.hospital_id" placeholder="请选择" size="medium" disabled>
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.phone" size="medium" disabled />
          </el-form-item>
          <el-form-item label="所属分组">
            <el-select v-model="form.group_id" placeholder="请选择" size="medium" multiple disabled>
              <el-option
                v-for="item in groupOptions"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="专业基地">
            <el-input v-model="form.base_title" size="medium" disabled></el-input>
          </el-form-item>
          <el-button type="primary" size="medium" @click="changeBtn">{{ showBtn?'保存资料':'修改资料' }}</el-button>
        </div>
        <div v-else>
          <el-form-item label="密码">
            <el-input v-model="password" size="medium" type="password">
              <i slot="suffix" class="el-input__icon el-icon-edit" @click="modifyShow(1)" />
            </el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.phone" size="medium">
              <i slot="suffix" class="el-input__icon el-icon-edit" @click="modifyShow(2)" />
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <modifyInfo :modify-obj="modifyObj" @update:modifyObj="modifyUpdate" @updateInfo="updateInfo" />
  </div>
</template>
<script>
import modifyInfo from './child/modify.vue'
import { getInfo, modifyUser } from '@/http/index'
import uploadBtn from '../../components/uploadImage/index.vue'
export default {
  components: { modifyInfo, uploadBtn },
  data() {
    return {
      tabIndex: 0,
      options: [],
      tabList: [{
        name: '基本设置'
      }, {
        name: '安全设置'
      }],
      form: {},
      modifyObj: {
        modifyVisible: false,
        type: null
      },
      password: '123456',
      groupOptions: [],
      showBtn: false
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    changeImg(file) {
      this.form.avatar = file;
      this.saveInfo();
    },
    // 手机号做脱敏处理
    phoneHide() {
      const reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
      var phone = this.form.mobile.replace(reg, '$1****$2');
      return phone; // 输出为131****1234
    },
    async getUserInfo() {
      const res = await getInfo({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      })
      if (res.code === 200) {
        this.$store.commit('editUserInfo', res.data);
        this.form = res.data;
        this.form.phone = this.phoneHide();
        this.options = res.data.hospital;
        this.groupOptions = res.data.hospital.find(item => item.id === this.form.hospital_id).group;
        this.form.group_id = [];
        this.groupOptions.map(item => this.form.group_id.push(item.id))
      }
    },
    changeBtn() {
      if (this.showBtn) {
        this.saveInfo()
      }
      this.showBtn = !this.showBtn
    },
    async saveInfo() {
      const res = await modifyUser({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        avatar: this.form.avatar,
        nickname: this.form.nickname
      })
      if (res.code === 200) {
        this.showBtn = false;
        this.$message.success('修改成功')
        this.getUserInfo();
      }
    },
    tabClick(e) {
      this.tabIndex = e;
    },
    modifyShow(e) {
      this.modifyObj = {
        type: e,
        modifyVisible: true,
        mobile: this.form.mobile,
        phone: this.form.phone
      }
    },
    modifyUpdate() {
      this.modifyObj = {
        type: null,
        modifyVisible: false
      }
    },
    updateInfo() {
      this.modifyObj = {
        type: null,
        modifyVisible: false
      }
      this.getUserInfo();
    }

  }
}
</script>
<style lang="scss" scoped>
.el-input,.el-select{
    width: 700px;
}
::v-deep{
    .right .el-form-item__label{
        line-height: 1;
    }
}
.personal{
    display: flex;
    height: 100%;
    .left{
        width: 220px;
        margin-right: 16px;
        .personal_tab{
            padding: 14px 24px;
            background: #fff;
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #606060;
        }
        .active{
            background: #FFF6F4;
            border-right: 2px solid #DD594A;
            color: #DD594A;
        }
    }
    .right{
        flex: 1;
        height: 100%;
        background-color: #fff;
        padding: 28px 24px;
        height: 100%;
        overflow-y: scroll;
        .title{
            font-size: 16px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #303030;
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            span{
                display: inline-block;
                width: 3px;
                height: 16px;
                background: #DD594A;
                margin-right: 4px;
            }
        }
        .avtar_box{
            display: flex;
            align-items: center;
            .avtar{
                width: 64px;
                height: 64px;
                border-radius: 8px 8px 8px 8px;
            }
            .btn{
                line-height: 1;
                cursor: pointer;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #303030;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #EEEEEE;
                padding: 4px 10px;
                margin-left: 16px;
                background-color: #fff;
            }
        }

    }
}
</style>
